import styled from "@emotion/styled";
import {
  border,
  BorderProps,
  boxShadow,
  BoxShadowProps,
  color,
  ColorProps,
  display,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
  zIndex,
  ZIndexProps,
} from "styled-system";
import React from "react";

export type BoxProps = SpaceProps &
  BorderProps &
  ColorProps &
  LayoutProps &
  ZIndexProps &
  PositionProps &
  TypographyProps & {
    as?: string;
    id?: string;
    className?: string;
    href?: string;
  };

const Box: React.FC<BoxProps> = styled.div(
  {
    boxSizing: "border-box",
    minWidth: 0,
  },
  border,
  space,
  color,
  layout,
  zIndex,
  position,
  typography,
  display,
);

export type FlexProps = SpaceProps &
  BorderProps &
  ColorProps &
  LayoutProps &
  FlexboxProps &
  ZIndexProps &
  PositionProps &
  BoxShadowProps &
  TypographyProps & {
    as?: string;
    id?: string;
    className?: string;
  };

const Flex = styled.div<FlexProps>`
  display: flex;
  ${border};
  ${space};
  ${color};
  ${layout};
  ${flexbox};
  ${zIndex};
  ${position};
  ${typography};
  ${boxShadow};
`;

const FlexList: React.FunctionComponent<FlexProps> = styled.ul`
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0;
  ${border};
  ${space};
  ${color};
  ${layout};
  ${flexbox};
  ${zIndex};
  ${position};
  ${typography};
  ${boxShadow};
`;

export { Box, Flex, FlexList };
